// PayrollForm.js
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Form, Button, Col, Row, Card, Container, Spinner, Modal } from 'react-bootstrap';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import TopBar from '../../components/TopBar';
import PageHeader from '../../components/PageHeader';
import Layout from '../../components/Layout';
const PayrollForm = () => {
  const { employeeId, month } = useParams();
  const navigate = useNavigate();
  const [employee, setEmployee] = useState(null);
  const [summary, setSummary] = useState(null);
  const [siteAllowance, setSiteAllowance] = useState(0);
  const [deductions, setDeductions] = useState(0);
  const [loan, setLoan] = useState(0);
  const [netSalary, setNetSalary] = useState(0);
  const [showSuccess, setShowSuccess] = useState(false);
  const [hourly_rate, setHourly_rate] = useState(0);
  const [house_keeping, setHouse_keeping] = useState(0);
  const [other_deductions, setOther_deductions] = useState(0);
  const [total_deductions, setTotal_deductions] = useState(0);
  const [other_allowance, setOther_allowance] = useState(0);
  const [totalHours, setTotalHours] = useState(0);
  const [pfDetails, setPfDetails] = useState({ employeeContribution: 0, employerContribution: 0 });

  // Calculate PF contributions
  useEffect(() => {
    if (employee?.pf_enabled && summary?.gross_salary) {
      const basicSalary = summary.gross_salary * 0.5; // Assuming 50% of gross goes to basic for PF calculation
      const employeeContribution = Math.min(basicSalary * 0.12, 1800); // 12% of basic, max 1800
      const employerContribution = Math.min(basicSalary * 0.12, 1800); // 12% of basic, max 1800
      setPfDetails({ employeeContribution, employerContribution });
    }
  }, [employee, summary]);

  // Calculate total deductions and net salary whenever any value changes
  useEffect(() => {
    // Calculate total deductions
    const deductionsTotal = Number(loan || 0) + Number(house_keeping || 0) + Number(other_deductions || 0);
    setTotal_deductions(deductionsTotal);

    // Calculate net salary
    const baseSalary = summary?.gross_salary || 0;
    const calculatedNetSalary = (Number(baseSalary) + Number(siteAllowance || 0) + Number(other_allowance || 0)) - deductionsTotal;
    setNetSalary(calculatedNetSalary);
  }, [loan, house_keeping, other_deductions, siteAllowance, other_allowance, summary]);


  useEffect(() => {
    api.get(`/employees/${employeeId}`).then(res => setEmployee(res.data));
    api.get(`/payrolls/monthly-summary?month=${month}`).then(res => {
      const data = res.data.data.find(item => item.employee_id == employeeId);
      setSummary(data);
    });
  }, [employeeId, month]);

  // useEffect(() => {
  //   if (summary) {
  //     const gross = summary.gross_salary + parseFloat(siteAllowance || 0);
  //     const net = gross - parseFloat(deductions || 0) - parseFloat(loan || 0);
  //     setNetSalary(net);
  //   }
  // }, [summary, siteAllowance, deductions, loan]);

  const handleSubmit = (e) => {
    e.preventDefault();
    api.post('/payrolls/calculate', {
      employee_id: employeeId,
      month,
      base_salary: summary.gross_salary,
      site_allowance: siteAllowance,
      net_salary: netSalary,
      hourly_rate:employee.hourly_rate,
      emp_code:employee.emp_code,
      other_allowance:other_allowance,
      house_keeping:house_keeping,
      other_deduction:other_deductions, 
      loan_deduction:loan, 
      total_deductions:total_deductions,
      total_hours:summary.total_hours,
    })
    .then(() => {
      setShowSuccess(true);
    });
  };

  const handleModalClose = () => {
    setShowSuccess(false);
    navigate('/payroll-summary?month=' + month);
  };

  if (!summary || !employee) return <div className="text-center mt-5"><Spinner animation="border" /></div>;

  return (
    <Layout>
      <PageHeader title={`Payroll for ${employee.name} (${moment(month).format('MMMM YYYY')})`} />
    <Container fluid className="mt-4">
      <Card>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
          
          
          
            <Row className="mb-3">
            <Col md={4}><strong>Emp Code:</strong> {employee.emp_code}</Col>
              <Col md={4}><strong>Salary Type:</strong> {summary.salary_type}</Col>
              <Col md={4}><strong>Total Hours:</strong> {summary.total_hours}</Col>
              {/* <Col md={4}><strong>Hourly Rate:</strong> {employee.hourly_rate}</Col> */}

              <Col md={4}><strong>Gross Salary:</strong> ₹{summary.gross_salary}</Col>
            </Row>
            <Row>
            <Col md={5} className="mb-3">
              <Card className="mb-3">
                <Card.Header>Salary Calculation</Card.Header>
                <Card.Body>
                  <Row className="m-3">
                
                  <Col md={6} className="mb-3">
                    <Form.Label>Other Allowance</Form.Label>
                    <Form.Control type="number" value={other_allowance} onChange={(e) => setOther_allowance(e.target.value)} />
                  </Col>
                
                 

                
                  <Col md="6" className="mb-3">
                    <Form.Label>Other Deductions</Form.Label>
                    <Form.Control type="number" value={other_deductions} onChange={(e) => setOther_deductions(e.target.value)} />
                  </Col>
              
                
                </Row>

                <Row className="m-4">
                <Col md={6}>
                    <Form.Label>Total Deductions</Form.Label>
                    <Form.Control type="number" value={total_deductions} readOnly />
                  </Col>
                  <Col md={6}>
                    <Form.Label>Net Salary</Form.Label>
                    <Form.Control type="number" value={netSalary} readOnly />
                  </Col>
                  </Row>
                </Card.Body>
              </Card>
             </Col>
            <Col md={7}>
              <Card>
                <Card.Header>Calculation Summary</Card.Header>
                <Card.Body>
                  <Row className="mb-2">
                    <Col md={8}><strong>Base Salary :</strong></Col>
                    <Col md={4} className="text-end">₹ {summary?.gross_salary || 0}</Col>
                  </Row>
                  
                  {employee?.pf_enabled && (
                    <>
                      <Row className="mb-1" style={{ color: '#6c757d', fontSize: '0.9em' }}>
                        <Col md={8} className="ps-4">- Employee PF Contribution (12% of Basic):</Col>
                        <Col md={4} className="text-end">₹ {pfDetails.employeeContribution.toFixed(2)}</Col>
                      </Row>
                      <Row className="mb-1" style={{ color: '#6c757d', fontSize: '0.9em' }}>
                        <Col md={8} className="ps-4">+ Employer PF Contribution (12% of Basic):</Col>
                        <Col md={4} className="text-end">₹ {pfDetails.employerContribution.toFixed(2)}</Col>
                      </Row>
                    </>
                  )}
                  
                  <Row className="mb-2">
                    <Col md={8}><strong>+ Other Allowance:</strong></Col>
                    <Col md={4} className="text-end">₹ {Number(other_allowance || 0)}</Col>
                  </Row>
                  <hr />
               
              
                  <Row className="mb-2">
                    <Col md={8}><strong>- Other Deductions:</strong></Col>
                    <Col md={4} className="text-end">₹ {Number(other_deductions || 0)}</Col>
                  </Row>
                  <hr />
                  <Row className="mb-2">
                    <Col md={8}><strong>Total Deductions:</strong></Col>
                    <Col md={4} className="text-end">
                      ₹ {employee?.pf_enabled 
                        ? (total_deductions + pfDetails.employeeContribution).toFixed(2)
                        : total_deductions.toFixed(2)
                      }
                      {employee?.pf_enabled && 
                        <div className="text-muted small">
                          (Including PF: ₹{pfDetails.employeeContribution.toFixed(2)})
                        </div>
                      }
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col md={8}><strong>Net Salary:</strong></Col>
                    <Col md={4} className="text-end fw-bold">₹ {netSalary}</Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>


            <Button type="submit" variant="success">Save Payroll</Button>
            
          </Form>
        </Card.Body>
      </Card>

      {/* Success Modal */}
      <Modal show={showSuccess} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>Payroll has been saved successfully!</Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleModalClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
    </Layout>
  );
};

export default PayrollForm;
